import { useEffect, useState } from "react";
import { WorkOrder } from "../../models/workOrderTypes";
import { dedupeColumnsByIdentity } from "../boardColumnUtils";

type PositionField = "statusPosition" | "techPosition" | "priorityPosition";

interface BoardColumn {
  identity?: number;
  workOrders: WorkOrder[];
}

interface UseBoardColumnsOptions {
  thenByCreatedDateAsc?: boolean;
}

export function useBoardColumns<T extends BoardColumn>(
  storeData: T[] | undefined,
  positionField: PositionField,
  options?: UseBoardColumnsOptions,
): [T[], React.Dispatch<React.SetStateAction<T[]>>] {
  const [columns, setColumns] = useState<T[]>([]);
  const thenByCreatedDateAsc = options?.thenByCreatedDateAsc ?? false;

  useEffect(() => {
    if (!storeData) return;
    const uniqueStoreData = dedupeColumnsByIdentity(storeData);
    const sorted = uniqueStoreData.map((column) => ({
      ...column,
      workOrders: column.workOrders.slice().sort((a, b) => {
        const posDiff = (a[positionField] ?? 0) - (b[positionField] ?? 0);
        if (posDiff !== 0) return posDiff;
        if (!thenByCreatedDateAsc) return 0;
        return (
          new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime()
        );
      }),
    }));
    setColumns(sorted);
  }, [storeData, positionField, thenByCreatedDateAsc]);

  return [columns, setColumns];
}
